import { apiClient } from './api'

export interface ProjectQAResponse {
  id: number
  project_id: number
  // Backend stores a JSON blob — the component serializes a list of QA
  // standards. Kept loose at the service layer.
  qa_data: unknown[] | Record<string, unknown> | null
  created_at: string | null
  updated_at: string | null
}

export const projectQAService = {
  get(projectId: number): Promise<ProjectQAResponse> {
    return apiClient.get(`/api/v1/projects/${projectId}/qa/`).then((r) => r.data)
  },
  update(
    projectId: number,
    qa_data: unknown[] | Record<string, unknown>,
  ): Promise<ProjectQAResponse> {
    return apiClient.patch(`/api/v1/projects/${projectId}/qa/`, { qa_data }).then((r) => r.data)
  },
}
